const SET_HUB_FIELD = 'hub/SET_HUB_FIELD'
const SET_HUB_FIELDS = 'hub/SET_HUB_FIELDS'
const SET_HUB_ALL = 'hub/SET_HUB_ALL'
const SET_HUB_SWIPPED_CARDS = 'hub/SET_HUB_SWIPPED_CARDS'
const RESET_HUB = 'hub/RESET_HUB'

export { SET_HUB_FIELD, SET_HUB_FIELDS, SET_HUB_ALL, SET_HUB_SWIPPED_CARDS, RESET_HUB }
